import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Config, { priceForLanguage } from '../../lib/Config'
import { Sheet } from '../../lib/Types'
import Headline from '../Elements/Headline'
import Text from '../Elements/Text'
import { SheetType } from './lib/Enums/SheetType'

interface Props {
  sheet: Sheet
}

// Shared "trial ended" paywall body, used to gate actions on a sheet whose
// free trial has expired. Reuses the same copy as the Welcome* modals.
const TrialEndedPaywallContent: FC<Props> = ({ sheet }) => {
  const { t, i18n } = useTranslation(['budget', 'accounting', 'spreadsheet'])

  if (sheet.sheet_type === SheetType.ACCOUNTING) {
    const price = priceForLanguage(Config.PRICE_ACCOUNTING, i18n.language)
    return (
      <>
        <Headline>{t('accounting:welcome.trialEndedTitle')}</Headline>
        <Text className='my-6'>
          {t('accounting:welcome.trialEndedDescription', { price })}
        </Text>
      </>
    )
  }

  if (sheet.sheet_type === SheetType.SPREADSHEET) {
    const price = priceForLanguage(
      Config.PRICE_SPREADSHEET,
      i18n.language,
      Config.PRICE_SPREADSHEET_EUR,
    )
    return (
      <>
        <Headline>{t('spreadsheet:welcome.trialEndedTitle')}</Headline>
        <Text className='my-6'>
          {t('spreadsheet:welcome.trialEndedDescription', { price })}
        </Text>
      </>
    )
  }

  const price = priceForLanguage(Config.PRICE_BUDGET, i18n.language)
  return (
    <>
      <Headline>{t('budget:welcomeBudget.trialEndedTitle')}</Headline>
      <Text className='my-6'>
        {t('budget:welcomeBudget.trialEndedDescription', { price })}
      </Text>
    </>
  )
}

export default TrialEndedPaywallContent
